import { isEmpty } from './helpers/is-empty';
import { isNumeric } from './helpers/is-numeric';
import { ValidatorFunction } from '../types/validator-function.type';

export const min: ValidatorFunction = (value: any, args: { min: number }) => {
  if (isEmpty(value) || isEmpty(args)) {
    return null;
  }

  const tempValue = +value;
  const tempMin = +args?.min;

  if (!isNumeric(tempValue) || !isNumeric(tempMin)) {
    return null;
  }

  return tempValue < tempMin ? { min: { min: args?.min, actual: value } } : null;
};
